export interface BcApiEndpointDescriptor {
  name: string;
  url: string;
}

export interface RuntimeConfigPayload {
  runtimeConfigSource: string;
  useTaskpaneConfiguration: boolean;
  showDiagnosticsSection: boolean;
  bcApiEndpoint: string;
  bcApiEndpoints: BcApiEndpointDescriptor[];
  azureAppClientId: string;
  azureAppTenantId: string;
  bcApiAllowedHosts: string[];
  allowInsecureBcEndpoint: boolean;
}

export type RuntimeConfigFetchResult =
  | { ok: true; payload: RuntimeConfigPayload }
  | { ok: false; source: string; error: string };

export async function fetchRuntimeConfigPayload(
  fetchFn: typeof fetch,
  endpoint = "/api/runtime-config",
): Promise<RuntimeConfigFetchResult> {
  try {
    const resp = await fetchFn(endpoint, { headers: { Accept: "application/json" } });
    if (!resp.ok) {
      return {
        ok: false,
        source: `fallback (HTTP ${resp.status})`,
        error: `runtime-config HTTP ${resp.status}`,
      };
    }

    const data = await resp.json();
    return {
      ok: true,
      payload: {
        runtimeConfigSource: String(data?.runtimeConfigSource ?? "server"),
        useTaskpaneConfiguration: data?.useTaskpaneConfiguration !== false,
        showDiagnosticsSection: data?.showDiagnosticsSection !== false,
        bcApiEndpoint: String(data?.bcApiEndpoint ?? "").trim(),
        bcApiEndpoints: Array.isArray(data?.bcApiEndpoints)
          ? data.bcApiEndpoints
              .map((item: any) => ({
                name: String(item?.name ?? "").trim(),
                url: String(item?.url ?? "").trim(),
              }))
              .filter((item: BcApiEndpointDescriptor) => item.url.length > 0)
          : [],
        azureAppClientId: String(data?.azureAppClientId ?? "").trim(),
        azureAppTenantId: String(data?.azureAppTenantId ?? "").trim(),
        bcApiAllowedHosts: Array.isArray(data?.bcApiAllowedHosts)
          ? data.bcApiAllowedHosts
              .map((value: any) =>
                String(value ?? "")
                  .trim()
                  .toLowerCase(),
              )
              .filter((value: string) => value.length > 0)
          : [],
        allowInsecureBcEndpoint: data?.allowInsecureBcEndpoint === true,
      },
    };
  } catch {
    return {
      ok: false,
      source: "fallback (fetch failed)",
      error: "runtime-config fetch failed",
    };
  }
}
